<template>
  <div class="flex gap-2 items-center">
    <input
      :id="value"
      type="radio"
      class="form-radio h-4 w-4 rounded-full border-gray-400 focus:outline-none focus:ring-0 focus:ring-offset-0 checked:text-secondary-500"
      :class="[
        size === 'small' ? 'h-[0.6875rem] w-[0.6875rem]' : '',
        size === 'medium' ? 'h-4 w-4' : '',
        size === 'large' ? 'h-6 w-6' : ''
      ]"
      :name="groupName"
      :value="value"
      :checked="checked"
      @change="changed($event)"
    />
    <label v-if="label" class="text-xs capitalize" :for="value">{{ label }}</label>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Emits {
  (e: 'update:modelValue', modelValue: string): void;
}

const emit = defineEmits<Emits>();

interface Props {
  modelValue: string;
  groupName: string;
  value: string;
  label?: string;
  size?: 'small' | 'medium' | 'large';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  label: undefined
});

const checked = computed(() => props.value === props.modelValue);

function changed(value: Event) {
  if ((value.target as HTMLOptionElement).value === props.value) {
    emit('update:modelValue', props.value);
  }
}
</script>
